// extracted by mini-css-extract-plugin
export default {"addCustomerSection":"style_addCustomerSection__7NZl5","actionsSection":"style_actionsSection__xpq2X","formSection":"style_formSection__t90U3"};